<template>
  <div id="addpaying" class="contenedor">
    <Sidebar></Sidebar>
    <loader :show="show" />
    <v-container fluid class="base text-center ma-0 px-0 pt-6 pb-0">
      <v-row no-gutters class="titulo">Alta Empresa Pagadora</v-row>
      <v-row no-gutters class="datos">
        <v-col
          cols="12"
          xs="12"
          sm="12"
          md="12"
          lg="12"
          xl="12"
          class="mt-11 mb-2"
        >
          <div class="form-group inputEnterprise">
            <label for="rs" style="width: 10% !important; margin-left: -0.1%"
              >Razón Social</label
            >
            <input
              type="text"
              name="rs"
              id="rs"
              v-model="reason"
              placeholder="Obligatorio"
              autocomplete="false"
              required
              maxlength="35"
              @keypress="alfaNumerico($event)"
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterprise">
            <label for="rfc">RFC</label>
            <input
              type="text"
              name="rfc"
              id="rfc"
              v-model="rfc"
              maxlength="13"
              minlength="13"
              placeholder="Obligatorio"
              autocomplete="false"
              required
              @keypress="alfaNumerico($event)"
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterprise">
            <label for="imss">IMSS</label>
            <input
              type="text"
              name="imss"
              id="imss"
              placeholder="ABC12345102"
              autocomplete="false"
              v-model="imss"
              minlength="11"
              maxlength="11"
              @keypress="alfaNumerico($event)"
            />
          </div>
        </v-col>
        <v-col
          class="pb-0"
          cols="12"
          xs="6"
          sm="6"
          md="6"
          lg="6"
          xl="6"
          justify="center"
          id="previewRow"
        >
          <v-row align-content="center" justify="center">
            <img
              id="preview"
              v-if="url"
              :src="url"
              alt="Logotipo"
              style="max-width: 300px !important; max-height: 150px !important"
            />
          </v-row>
        </v-col>
        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="mt-5"
          >Domicilio</v-col
        >

        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterprise">
            <label for="pais">País</label>
            <input
              type="text"
              name="pais"
              id="pais"
              v-model="country"
              placeholder="Obligatorio"
              autocomplete="false"
              required
              @keypress="alfaNumerico($event)"
              readonly
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterprise">
            <label for="cp">C.P.</label>
            <input
              type="text"
              name="cp"
              id="cp"
              maxlength="5"
              placeholder="Obligatorio"
              required
              autocomplete="false"
              v-model="cp"
              @keypress="isNumber($event)"
              @change="consultaDireccion()"
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterprise">
            <label for="estado">Estado</label>
            <input
              type="text"
              name="estado"
              id="estado"
              placeholder="Obligatorio"
              autocomplete="false"
              required
              maxlength="35"
              v-model="state"
              readonly
              @keypress="alfaNumerico($event)"
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterprise">
            <label for="municipio">Municipio</label>
            <input
              type="text"
              name="municipio"
              id="municipio"
              placeholder="Obligatorio"
              autocomplete="false"
              required
              v-model="municipality"
              @keypress="alfaNumerico($event)"
              readonly
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterprise">
            <label for="colonia">Colonia</label>

            <select name="suburb" id="suburb" v-model="suburb">
              <option disabled value="0">Selecciona Colonia</option>
              <option
                v-for="suburb in suburbs"
                :key="suburb.id"
                v-bind:value="suburb.id"
              >
                {{ suburb.name }}
              </option>
            </select>
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
          <div class="form-group inputEnterprise">
            <label for="calle" style="margin-left: 1%; width: 10%">Calle</label>
            <input
              type="text"
              name="calle"
              id="calle"
              v-model="street"
              maxlength="35"
              required
              autocomplete="false"
              placeholder="Obligatorio"
              @keypress="alfaNumerico($event)"
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterprise">
            <label for="ne">N° Exterior</label>
            <input
              type="text"
              name="ne"
              id="ne"
              placeholder="Obligatorio"
              autocomplete="false"
              required
              v-model="exterior"
              @keypress="alfaNumerico($event)"
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterprise">
            <label for="ni">N° Interior</label>
            <input
              type="text"
              name="ni"
              id="ni"
              placeholder="Obligatorio"
              v-model="interior"
              autocomplete="false"
              required
              maxlength="20"
              @keypress="alfaNumerico($event)"
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterprise">
            <label>Logotipo</label>
            <label for="log" class="custom-file-upload">Seleccionar</label>
            <input
              type="file"
              name="logo"
              id="log"
              class="inputs"
              @change="onFileChange($event)"
            />
          </div>
        </v-col>
        <v-col cols="12" sm="12" class="mt-11">
          <div class="form-group text-center terminos mt-4">
            <button
              class="boton ml-12"
              style="float: none !important"
              @click="regresar()"
            >
              Regresar
            </button>
            <button
              class="boton ml-12"
              style="float: none !important"
              @click="validacion()"
            >
              Guardar
            </button>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <!--Error-->
    <v-dialog v-model="error" width="450">
      <v-card>
        <v-card-title class="red white--text">
          <span class="headline">Empresa Pagadora</span>
        </v-card-title>
        <v-card-text>
          <br />
          <h3 class="text-md-center text-sm-center text-lg-center">
            {{ respuesta }}
          </h3>
          <br />
          <ul style>
            <li v-for="error in errors" :key="error.name">{{ error }}</li>
          </ul>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="warning" text @click="error = false">Corregir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="advice" width="400">
      <v-card>
        <v-card-title class="orange white--text">
          <span class="headline">Alerta</span>
        </v-card-title>
        <v-card-text>
          <br />
          <h3 class="text-md-center text-lg-center text-sm-center">
            ¿Esta seguro de almacenar la empresa?
          </h3>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="error" text @click="aux()">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="guardar()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--Confirmación de datos-->
    <v-dialog v-model="confirmation" width="400">
      <v-card>
        <v-card-title class="orange white--text">
          <span class="headline">Empresa</span>
        </v-card-title>
        <v-card-text>
          <br />
          <h3 class="text-lg-center text-sm-center text-md-center">
            {{ respuesta }}
          </h3>
          <br />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="aux()">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Sidebar from "@/components/Sidebar.vue";
import Loader from "@/components/Loader";
export default {
  components: {
    Sidebar,
    Loader,
  },
  data() {
    return {
      stepn: "5-N",
      error: false,
      errors: [],
      respuesta: "",
      show: false,
      dialog: false,
      rfc: "",
      imss: "",
      reason: "",
      errors: [],
      respuesta: "",
      confirmation: false,
      advice: false,
      error: false,
      country: "México",
      state: "",
      cp: "",
      exterior: "",
      interior: "",
      municipality: "",
      suburb: 0,
      street: "",
      address: [],
      suburbs: [],
      url: null,
      comercial: true,
      selectedFile: "",
    };
  },
  methods: {
    nombre() {
      localStorage.stepn = this.stepn;
    },
    onFileChange(evt) {
      const file = evt.target.files[0];
      this.url = URL.createObjectURL(file);
      var fileBase = evt.target.files[0];
      var reader = new FileReader();
      this.selectedFile = file;
      reader.onloadend = function () {
        console.log("RESULT", reader.result);
        sessionStorage.setItem("base64img", reader.result);
      };
      reader.readAsDataURL(fileBase);
    },
    alfaNumerico: function (evt) {
      var regex = new RegExp("^[a-zA-ZÀ-ÿ\u00f1\u00d10-9 ]+$"); // Letras y números
      var str = String.fromCharCode(!evt.charCode ? evt.which : evt.charCode);
      if (regex.test(str)) {
        return true;
      }
      evt.preventDefault();
      return false;
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if ((charCode > 31 && charCode < 48) || charCode > 57) {
        evt.preventDefault();
      } else return true;
    },
    validaImss() {
      var imss = this.imss;
      if (imss.length != 11) {
        this.errors.push("Número de IMSS incorrecto");
        return false;
      } else {
        console.log("Correcto");
        console.log(imss.length);
        return false;
      }
    },
    validaRfc() {
      var strCorrecta;
      strCorrecta = this.rfc;
      if (this.rfc.length == 12) {
        var valid = "^(([A-Z]|[a-z]){3})([0-9]{6})((([A-Z]|[a-z]|[0-9]){3}))";
      } else {
        var valid =
          "^(([A-Z]|[a-z]|s){1})(([A-Z]|[a-z]){3})([0-9]{6})((([A-Z]|[a-z]|[0-9]){3}))";
      }
      var validRfc = new RegExp(valid);
      var matchArray = strCorrecta.match(validRfc);
      if (matchArray == null) {
        this.errors.push("El RFC es incorrecto favor de verificarlo.");
        return false;
      } else {
        console.log("Correcto");
        return true;
      }
    },
    validaCp() {
      console.log(this.cp);
      var cp = this.cp;
      if (cp.length != 5) {
        this.errors.push("Código Postal incorrecto");
        return false;
      } else {
        console.log("Correcto");
        console.log(cp.length);
        return false;
      }
    },
    validacion() {
      console.log("Logo: " + this.base64logo);
      this.errors = [];
      this.validaRfc();
      this.validaImss();
      this.validaCp();
      if (this.reason == "" || this.reason == " ") {
        this.errors.push("Se debe especificar la Razón Social.");
      }
      if (this.country == "" || this.country == " ") {
        this.errors.push("Se debe especificar el país.");
      }
      if (this.state == "" || this.state == " ") {
        this.errors.push("Se debe especificar el estado.");
      }
      if (this.municipality == "" || this.municipality == " ") {
        this.errors.push("Se debe especificar el municipio.");
      }
      if (this.suburb == "" || this.suburb == 0) {
        this.errors.push("Se debe especificar la colonia.");
      }
      if (this.street == "" || this.street == " ") {
        this.errors.push("Se debe especificar la calle.");
      }
      if (this.country == "" || this.country == " ") {
        this.errors.push("Se debe especificar el país.");
      }
      if (this.state == "" || this.state == " ") {
        this.errors.push("Se debe especificar el estado.");
      }
      if (this.exterior == "" || this.exterior == " ") {
        this.errors.push("Se debe especificar el número exterior.");
      }
      if (this.interior == "" || this.interior == " ") {
        this.errors.push("Se debe especificar el número interior.");
      }
      if (this.errors.length == 0) {
        return (this.advice = true);
      } else {
        this.respuesta = "Por favor corrige el siguiente error:";
        this.error = true;
      }
    },
    regresar() {
      this.socialReason = "";
      this.rfc = "";
      this.imss = "";
      this.pais = "";
      this.cp = "";
      this.estado = "";
      this.municipio = "";
      this.localidad = "";
      this.colonia = "";
      this.calle = "";
      this.exterior = "";
      this.interior = "";
      this.$router.push("/paying");
    },
    consultaDireccion() {
      if (this.cp.length == 5) {
        this.suburbs = [];
        this.show = true;
        axios
          .get(Server + "/direcciones/" + this.cp)
          .then((response) => {
            this.show = false;
            this.address = response.data;
            this.state = this.address[0].estado;
            this.municipality = this.address[0].municipio;
            this.address.forEach((value, index) => {
              this.suburbs.push({
                id: value.asentamientoId,
                name: value.colonia,
              });
            });
          })
          .catch((e) => {
            console.log(e);
            this.show = false;
          });
      } else {
        console.log("Menor a 5");
      }
    },
    aux() {
      this.confirmation = false;
      this.reason = "";
      this.imss = "";
      this.rfc = "";
      this.country = "";
      this.cp = "";
      this.state = "";
      this.municipality = "";
      this.suburb = "";
      this.exterior = "";
      this.interior = "";
      this.street = "";
      this.$router.push("/paying");
    },
    guardar() {
      this.advice = false;
      var data = new FormData();
      data.append("RazonSocial", this.reason);
      data.append("NSS", this.imss);
      data.append("RFC", this.rfc);
      data.append("Pais", this.country);
      data.append("CodigoPostal", this.cp);
      data.append("AsentamientoId", this.suburb);
      data.append("NumeroExterior", this.exterior);
      data.append("NumeroInterior", this.interior);
      data.append("Calle", this.street);
      data.append("EmpresaPagadora", true);
      if (this.selectedFile)
        data.append("Logo", this.selectedFile, this.selectedFile.name);
      this.show = true;
      axios
        .post(Server + "/empresas", data, {
          headers: {
            "Content-Type": "multipart/form-data",
          } /* {
          RazonSocial: this.reason,
          NSS: this.imss,
          RFC: this.rfc,
          Pais: this.country,
          Logo: sessionStorage.getItem("base64img"),
          CodigoPostal: this.cp,
          AsentamientoId: this.suburb,
          NumeroExterior: this.exterior,
          NumeroInterior: this.interior,
          Calle: this.street,
        } */,
        })
        .then((response) => {
          console.log(response);
          this.show = false;
          this.reason = "";
          this.imss = "";
          this.rfc = "";
          this.country = "";
          this.cp = "";
          this.state = "";
          this.municipality = "";
          this.suburb = "";
          this.exterior = "";
          this.interior = "";
          this.street = "";
          this.respuesta = "La Empresa fue guardada con éxito";
          this.confirmation = true;
        })
        .catch((e) => {
          console.log(e);
          this.show = false;
          this.reason = "";
          this.imss = "";
          this.rfc = "";
          this.country = "";
          this.cp = "";
          this.state = "";
          this.municipality = "";
          this.suburb = "";
          this.exterior = "";
          this.interior = "";
          this.street = "";
          this.respuesta = "La Empresa no fue almacenada";
          this.confirmation = true;
        });
    },
    cancel() {
      this.reason = "";
      this.rfc = "";
      this.imss = "";
      this.country = "";
      this.cp = "";
      this.state = "";
      this.municipality = "";
      this.suburb = "";
      this.exterior = "";
      this.interior = "";
      this.street = "";
      this.$router.push("/enterprise");
    },
  },
  created() {
    this.nombre();
    sessionStorage.setItem("base64img", null);
  },
};
</script>
<style scoped>
input[type="file"] {
  display: none;
}
</style>
